export const SET_LOADING = "SET_LOADING";
export const GET_SUBSCRIPTION_PRODUCT_LIST = "GET_SUBSCRIPTION_PRODUCT_LIST";
export const GET_ACTIVE_SUBSCRIPTION_LIST = "GET_ACTIVE_SUBSCRIPTION_LIST";
